
import React, { forwardRef } from 'react';
import { MenuCategory, Language, MenuItem } from '../types';
import MenuItemCard from './MenuItemCard';

interface MenuSectionProps {
  category: MenuCategory;
  language: Language;
  recommendedItemId: number | null;
  onDishSelect: (dish: MenuItem) => void;
}

const MenuSection = forwardRef<HTMLElement, MenuSectionProps>(({ category, language, recommendedItemId, onDishSelect }, ref) => {
  if (category.items.length === 0) {
    return null;
  }
  
  return (
    <section id={category.id} ref={ref} className="mb-6 scroll-mt-4">
      {/* Category Header */}
      <div className="sticky top-0 z-20 -mx-5 px-5 py-1.5">
        <div className="bg-[var(--bg-card-80)] backdrop-blur-xl border border-[var(--glass-border)] shadow-sm rounded-xl px-4 py-2.5 flex items-center justify-between">
          <h2 className="text-base font-bold font-serif text-[var(--text-primary)] tracking-tight leading-none">
            {category.names[language]}
          </h2>
          <span className="text-[10px] font-bold text-[var(--text-secondary)] bg-[var(--neutral-bg)] px-2 py-0.5 rounded-full">
            {category.items.length}
          </span>
        </div>
      </div>
      
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
        {category.items.map((item, index) => (
          <MenuItemCard
            key={item.id}
            item={item}
            language={language}
            isRecommended={recommendedItemId === item.id}
            onSelect={() => onDishSelect(item)}
            isFeatured={false}
          />
        ))}
      </div>
    </section>
  );
});

MenuSection.displayName = 'MenuSection';
export default MenuSection;
